import ApiJob from 'types/api/Job';
import ApiJobNameSuggestion from 'types/api/JobNameSuggestion';
import ApiJobPreviw from 'types/api/JobPreview';
import ApiJobsSearchSuggestedTags from 'types/api/JobsSearchSuggestedTags';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import Job from 'models/Job';
import JobNameSuggestion from 'models/JobNameSuggestion';
import JobPreview from 'models/JobPreview';
import JobsSearchSuggestedTags from 'models/JobsSearchSuggestedTags';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    companySlug?: string;
    jobExperienceSlug?: string[];
    jobTimeSlug?: string[];
    jobCategorySlug?: string[];
    jobAgreementSlug?: string[];
    jobModeSlug?: string[];
    jobLanguageSlug?: string[],
    salaryFrom?: number;
    name?: string;
    jobCompanyCitySlug?: string;
    jobCompanyCityDistrictSlug?: string;
    companyCitySearch?: string;
    topOffer?: boolean;
    sort?: string;
    isCvRequired?: boolean;
    jobsSearchSuggestedTagId?: string;
    companyId?: string;
    createSource?: string;
    cbopUrl?: string;
}
export const list = async (params?: ListParams): Promise<ListCollection<Job>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobs, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resourceJobs = data && data[ApiResources.Jobs];
    const resourcejobsSearchSuggestedTags = data && data[ApiResources.JobsSearchSuggestedTags];

    if(!data || !resourceJobs) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resourceJobs
            .elements
            .map((element: ApiJob) => new Job(element)),
        additionalElements: Array.isArray(resourcejobsSearchSuggestedTags)
            ? resourcejobsSearchSuggestedTags.map((suggestedTags: ApiJobsSearchSuggestedTags) => new JobsSearchSuggestedTags(suggestedTags))
            : null,
        meta: resourceJobs.meta,
    };
};

export interface NameSuggestionsParams {
    keyword?: string;
}
export const nameSuggestions = async (params?: NameSuggestionsParams): Promise<JobNameSuggestion[]> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobsNameSuggestions, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobNameSuggestions];

    return Array.isArray(resource)
        ? resource.map((element: ApiJobNameSuggestion) => new JobNameSuggestion(element))
        : [];
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<Job> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJob, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJob = data && data[ApiResources.Job];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new Job(resource);
};

export interface PreviewParams {
    id: string;
}
export const preview = async (params: PreviewParams): Promise<JobPreview> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobPreview, params),
        cache: { enabled: false }     // disable redis cache for preview requests
    });

    const data = response?.payload?.data;
    const resource: ApiJobPreviw = data && data[ApiResources.Job];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobPreview(resource);
};
